import { useState, useEffect, useRef } from 'react';

const hasAnyMatchDynamic = (dataList, search) => {
    const cleaned = search.toLowerCase().replace(/\s+/g, '');
    if (!cleaned) return true;
    return (dataList || []).some(item =>
        (item?.name || item?.ledger_name || item?.symbol || '')
            .toLowerCase().replace(/\s+/g, '').includes(cleaned)
    );
};

export const useDropdownFilterForDynamicInput = ({
    dataList,
    searchInput,
    inputRef,
    defaultItem = { id: '1', name: 'Not Applicable' },
}) => {
    const [filteredData, setFilteredData] = useState([]);
    const dataListRef = useRef(dataList);
    useEffect(() => { dataListRef.current = dataList; }, [dataList]);

    // Attach typeahead restriction to the input
    useEffect(() => {
        const inputEl = inputRef?.current || (inputRef?.tagName ? inputRef : null);
        if (!inputEl) return;

        const ALWAYS_ALLOW = new Set([
            'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
            'Home', 'End', 'Escape', 'Enter', 'Tab', 'F1', 'F2', 'F3', 'F4',
            'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12',
        ]);

        const handleKeyDown = (e) => {
            if (ALWAYS_ALLOW.has(e.key) || e.ctrlKey || e.altKey || e.metaKey) return;
            if (e.key.length !== 1) return;

            const { value, selectionStart, selectionEnd } = inputEl;
            const previewValue = value.slice(0, selectionStart) + e.key + value.slice(selectionEnd);

            if (!hasAnyMatchDynamic(dataListRef.current, previewValue)) {
                e.preventDefault();
                e.stopPropagation();
            }
        };

        inputEl.addEventListener('keydown', handleKeyDown);
        return () => inputEl.removeEventListener('keydown', handleKeyDown);
    }, [inputRef]);

    useEffect(() => {
        const cleanedSearchInput = searchInput?.toLowerCase().replace(/\s+/g, '') || '';
        const lowercaseSearchInput = searchInput?.toLowerCase() || '';

        const filteredSuggestions = dataList.filter((item) =>
           (item?.name || item?.ledger_name || item?.symbol)?.toLowerCase()?.replace(/\s+/g, '').includes(cleanedSearchInput)
        );

        const shouldUseFilteredData =
            searchInput !== '' &&
            inputRef?.selectionStart > 0;
        setFilteredData(shouldUseFilteredData ? filteredSuggestions : dataList);
    }, [dataList, searchInput, inputRef?.selectionStart]);

    return { filteredData };
};
